<div>
    <!------------------------------------------ Back ------------------------------------>
    <div class="absolute w-[40px] h-[37px] bg-white shadow-lg rounded-full flex justify-center items-center m-2 z-[49]" 
            style="box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25) ;"
            (click)="goback()"
    >
        <img src="icons/Payment/back-payment.png" alt="back" class="w-[30px] h-[30px]" />
    </div>
    <!------------------------------------------- Header ------------------------------------->
    <div class="flex flex-col justify-center items-center shadow  mb-2 py-4 bg-[#FFE9A2]">
        <label class="block font-bold text-black text-xl mb-1">{{
            currentLang === "TH" ? "หัวข้อที่ต้องการแก้ไข" : "Subject to be edited"
        }}</label>
    </div>
    <!------------------------------------------- Body ------------------------------------->
    <div class="relative px-4 flex flex-col justify-start items-center w-full">
        <div class="relative w-full">
            <select
            [(ngModel)]="selectedOption"
            class=" w-full text-sm border border-gray-300 rounded-lg px-4 py-2 pr-10 text-gray-700  appearance-none bg-white
                    focus:outline-none focus:ring-2 focus:ring-yellow-300
            "
            >
            <option *ngFor="let type of FormOptions" [value]="type.value">
                {{ type.label }}
            </option>
            </select>

            <!-- ไอคอนลูกศร ▼ -->
            <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
            >
            <svg
                class="h-4 w-4 text-gray-500"
                viewBox="0 0 20 20"
                fill="currentColor"
            >
                <path
                fill-rule="evenodd"
                d="M10 12a1 1 0 0 1-.7-.3l-3-3a1 1 0 0 1 1.4-1.4L10 9.6l2.3-2.3a1 1 0 1 1 1.4 1.4l-3 3a1 1 0 0 1-.7.3z"
                clip-rule="evenodd"
                />
            </svg>
            </div>
        </div>
        <!-- ข้อมูลส่วนตัว -->
        <div class="w-full pt-6 ">
        <div class="border-b border-gray-300 mb-2">
            <div class="flex flex-row justify-start items-center gap-2">
                <div class="w-10 h-12">
                    <img src="data:image/png;base64,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" alt="user--v1">
                </div>
                <div class="flex flex-col justify-start items-start">
                    <p class="font-bold text-black text-md">
                        {{
                        currentLang === "TH" ? "ข้อมูลบัตรสมาชิก" : "Member card information."
                        }}
                    </p>
                    <label class="text-[12px] text-gray-500 mb-2">
                        {{
                        currentLang === "TH"
                            ? "กรุณาระบุข้อมูลส่วนที่ต้องการแก้ไข"
                            : "Please specify the information you would like to edit."
                        }}
                    </label>
                </div>
            </div>

        </div>

        <!-- บัตรสมาชิก -->
        <div class="mb-3">
            <label class="block font-medium text-sm text-gray-700 mb-1"
            >{{ currentLang === "TH" ? "บัตรสมาชิก" : "Member card" }}
            <span class="text-red-500"
                >{{ currentLang === "TH" ? "(จำเป็น)" : "(Required)" }}
            </span></label
            >
            <div class="flex">
            <input
                type="text"
                [placeholder]="currentLang === 'TH' ? 'บัตรสมาชิก' : 'Member card'"
                [(ngModel)]="cardName"
                class="flex-grow text-sm border border-gray-300 rounded-l-lg px-4 py-2 
                        focus:outline-none focus:ring-2 focus:ring-yellow-400"
                readonly
            />
            <button
                class="bg-yellow-400 text-white px-4 text-sm py-2 rounded-r-lg hover:bg-yellow-600"
                (click)="openCardModal()"
            >
                {{ currentLang === "TH" ? "เลือกบัตร" : "Select" }}
            </button>
            </div>
        </div>

        <div class="mb-3">
            <label class="block font-medium text-sm text-gray-700 mb-1">{{
            currentLang === "TH" ? "วันหมดอายุ" : "Expiration date"
            }}</label>
            <input
            type="text"
            placeholder="20/05/2025 00:00"
            [(ngModel)]="expire"
            readonly
            class="w-full border text-sm border-gray-300 rounded-lg px-4 py-2 
                    focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
        </div>
        <div class="mb-3">
            <label class="block font-medium text-sm text-gray-700 mb-1">{{
            currentLang === "TH" ? "ประเภทรถ" : "Vehicle type"
            }}</label>
            <input
            type="text"
            placeholder="รถยนต์"
            [(ngModel)]="carType"
            readonly
            class="w-full border border-gray-300 text-sm rounded-lg px-4 py-2 
            focus:outline-none focus:ring-2 focus:ring-yellow-400"
            />
        </div>

        <div class="mb-3">
            <label class="block font-medium text-sm text-gray-700 mb-1">
            {{
                currentLang === "TH"
                ? "ทะเบียนรถที่ต้องการเปลี่ยน"
                : "Select the license plate you wish to update"
            }}
            <span class="text-red-500">
                {{
                currentLang === "TH"
                    ? "(จำเป็น) แก้ไขได้สูงสุด : " + oldPlateNumber + " คัน"
                    : "(Required) Maximum editable :" + oldPlateNumber + " vehicles"
                }}
            </span>
            </label>

            <div
            class="space-y-2 relative h-[200px] overflow-y-scroll border border-gray-300 rounded-md shadow-sm bg-white p-2"
            *ngIf="myVehicle.length > 0"
            >
            <div
                *ngFor="let vehicle of myVehicle"
                class="flex items-center space-x-2"
            >
                <div class="flex items-center justify-center border border-gray-300 rounded-md"
                     [ngClass]="{ 'border-yellow-400 bg-yellow-400': selectedVehicles.includes(vehicle), }"
                >
                    <input
                    type="checkbox"
                    [value]="vehicle.vehicle_id"
                    (change)="toggleVehicleSelection(vehicle, $event)"
                    [checked]="selectedVehicles.includes(vehicle)"
                    class="h-4 w-4 text-yellow-500 border-gray-300 rounded appearance-none focus:ring-yellow-400 z-[1]"
                    />
                    <div class="w-3 h-3 absolute z-[0] " *ngIf="selectedVehicles.includes(vehicle)" >
                        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA8ElEQVR4nO2XsQ3CMBAAHxaggRrBAAwCEsOlospEVNAj0TIAguoQikBRwCJOQvwPf12a+M52LEfEcRzH+ReAITAViwADYAOcgIUYlX9gJ4JXeTsRFHs+5z0XYCkGZ/7OFViLVnD5RODyicDlE4HLJ8Llf16eYqBxJy+rfzFbdSmfAUdgZnHms9LLW0eklG8d0esHC4yAfWCwQ+zPdG97vgwwAXaBQWuvRNKjkpYRKs55GkaokG8aoUo+NkKlfETEXK18JSJ0xJ57PSq/tBI6Z75hhE75mhG65T9E2JAPRNiSr0RsTcqXb53PB8dxHInkBtH+kqUUXuTrAAAAAElFTkSuQmCC" alt="checkmark--v1">
                    </div>

                </div>
                <span class="text-sm text-gray-700">
                {{ vehicle.plate_number }} ({{ vehicle.province_name }})
                </span>
            </div>
            </div>

            <div *ngIf="myVehicle.length === 0">
            <p
                class="text-sm text-red-300 border border-gray-300 rounded-lg px-4 py-2"
            >
                {{
                currentLang === "TH"
                    ? "กรุณาเลือกบัตรสมาชิกก่อน"
                    : " Please select a member before"
                }}
            </p>
            </div>
        </div>

        <label class="block font-medium text-sm text-gray-700 mb-1">
            {{ currentLang === "TH" ? "เหตุผล" : "Reasoning" }}
            <span class="text-red-500">{{
            currentLang === "TH" ? "(จำเป็น)" : "(Required)"
            }}</span>
        </label>
        <textarea
            id="description"
            rows="4"
            [(ngModel)]="remark"
            class="bg-white w-full border text-sm border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400"
            [placeholder]="currentLang === 'TH' ? 'เหตุผล...' : 'Reason...'"
        ></textarea>
        <div class="mt-1">
            <div class="flex items-start mt-5">
            <label class="flex items-center cursor-pointer relative">
                <input
                type="checkbox"
                name="agree"
                [(ngModel)]="agree"
                (change)="validateForm()"
                class="peer h-4 w-4 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-yellow-400 checked:border-yellow-400"
                id="check1"
                />
                <span
                class="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-3.5 w-3.5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    stroke="currentColor"
                    stroke-width="1"
                >
                    <path
                    fill-rule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clip-rule="evenodd"
                    ></path>
                </svg>
                </span>
            </label>

            <!-- ข้อความ check box  -->
            <label
                for="checked-checkbox"
                class="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300 block text-left text-[10px]"
            >
                {{
                currentLang === "TH"
                    ? "ฉันได้อ่านและยอมรับข้อกำหนดที่เกี่ยวข้องกับการขอเปลี่ยนแปลงทะเบียนรถในบัตรสมาชิก"
                    : "I have read and accepted the applicable terms and conditions regarding the request to change the vehicle registration number on the membership card."
                }}
                {{ currentLang === "TH" ? "โดยการคลิกปุ่ม" : "By clicking the" }}
                <strong>{{
                currentLang === "TH" ? "ส่งคำร้อง" : "Submit Request"
                }}</strong>
                {{ currentLang === "TH" ? "ด้านล่าง" : "button below" }}
                {{
                currentLang === "TH"
                    ? "ถือว่าเป็นการลงนามแบบดิจิทัล ซึ่งมีผลผูกพันเช่นเดียวกับลายเซ็นจริง"
                    : "you are providing a digital signature that is legally binding, equivalent to a handwritten signature."
                }}

                <span class="text-red-500 font-semibold">
                {{
                    currentLang === "TH"
                    ? "กรุณาแนบรูปเล่มทะเบียนรถ และกรอกทะเบียนรถใหม่ให้ครบถ้วน"
                    : "Please attach an image of the vehicle registration book and complete the new license plate information."
                }}
                </span>

                <a
                class="text-blue-600 hover:underline dark:text-blue-500"
                (click)="openModal()"
                >
                {{
                    currentLang === "TH"
                    ? "ดูรายละเอียด: เงื่อนไขการบริการ / นโยบายความเป็นส่วนตัว"
                    : "See details: Terms of Service / Privacy Policy"
                }}
                </a>
            </label>
            </div>
        </div>
        </div>
    </div>
    <button
        (click)="save()"
        [disabled]="!isButton || error !== ''"
        [ngClass]="{
            'w-full mt-4 py-3 px-4 font-bold text-white  transition-all duration-300': true,
            'bg-yellow-400 hover:bg-yellow-600 cursor-pointer':
            isButton && error === '',
            'bg-gray-400 cursor-not-allowed': !isButton || error !== ''
        }"
        >
        {{ currentLang === "TH" ? "ส่งคำร้อง" : "Submit Request" }}
    </button>
</div>

<!-- Modal Select Vehicle -->
<div
  *ngIf="modalSelectCard"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 px-4"
>
  <div
    @slideUp
    class="bg-white w-full max-w-md md:max-w-lg max-h-[90vh] p-6 rounded-2xl shadow-2xl relative overflow-y-auto"
  >
    <!-- ปุ่มปิด -->
    <button
      (click)="modalSelectCard = false"
      class="absolute top-3 right-3 text-gray-400 hover:text-red-500 text-2xl"
      aria-label="ปิด"
    >
      &times;
    </button>

    <!-- หัวข้อ -->
    <h2 class="text-2xl font-bold text-gray-800 mb-6 text-center">
      {{ currentLang === "TH" ? "เลือกบัตรสมาชิก" : "Select" }}
    </h2>

    <!-- รายการบัตร -->
    <ul class="space-y-3">
      <li
        *ngFor="let cards of myCards"
        (click)="changeCard(cards)"
        class="p-4 bg-gray-50 border border-gray-200 rounded-lg hover:bg-blue-50 cursor-pointer transition shadow-sm hover:shadow-md"
      >
        <div class="font-semibold text-gray-800">
          {{ currentLang === "TH" ? "บัตรที่" : "Card issued by" }} :
          {{ cards.site_name }}
        </div>
        <div class="font-semibold text-gray-800">
          {{ currentLang === "TH" ? "จำนวนรถ" : "Total vehicles" }} :
          {{ cards.plate_number }} {{ currentLang === "TH" ? "คัน" : "" }}
          {{ currentLang === "TH" ? "ประเภท" : "Type" }} :
          {{ cards.vehicle_type }}
        </div>
        <div class="text-sm text-gray-500">
          {{ currentLang === "TH" ? "หมายเลขบัตร" : "Card code" }} :
          {{ cards.card_name }}
        </div>
        <div class="text-sm text-gray-500">
          {{ currentLang === "TH" ? "วันหมดอายุ" : "Expiration date" }} :
          {{ cards.expire_date | date : "dd/MM/yyyy HH:mm" }}
        </div>
      </li>
    </ul>
  </div>
</div>

<!-- Modal Confirm-->
<div
  *ngIf="false"
  class="fixed top-0 right-0 left-0 z-50 flex justify-center items-center w-full h-screen bg-black bg-opacity-50"
>
  <div class="bg-white rounded-lg shadow dark:bg-gray-700 max-w-md w-full p-6">
    <button
      type="button"
      (click)="showModal_confirm = false"
      class="absolute top-3 end-2.5 text-gray-400 hover:text-gray-900"
    >
      ✕
    </button>

    <div class="text-center">
      <svg
        class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
        />
      </svg>
      <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
        {{
          currentLang === "TH"
            ? "ต้องการเปลี่ยนแปลงข้อมูล"
            : "Request to Update Information"
        }}
      </h3>
      <p class="mb-5 text-sm text-gray-400 dark:text-gray-500">
        {{
          currentLang === "TH"
            ? "กรุณาตรวจสอบข้อมูลก่อนยืนยัน หากข้อมูลไม่ถูกต้องจะไม่สามารถแก้ไขได้ในภายหลัง ต้องติดต่อเจ้าหน้าที่"
            : "Please review the information carefully before confirming. Once submitted, it cannot be modified later. You will need to contact our staff for any corrections."
        }}
      </p>
      <button
        (click)="saveApi()"
        type="button"
        class="text-white bg-green-600 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
      >
        {{ currentLang === "TH" ? "ตกลง" : "Ok" }}
      </button>
      <button
        (click)="showModal_confirm = false"
        type="button"
        class="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 bg-white rounded-lg border border-gray-200 hover:bg-gray-100"
      >
        {{ currentLang === "TH" ? "ยกเลิก" : "Cancle" }}
      </button>
    </div>
  </div>
</div>
<app-pss-warn 
  *ngIf="showModal_confirm"
  [detail]="
          currentLang === 'TH'
            ? 'กรุณาตรวจสอบข้อมูลก่อนยืนยัน หากข้อมูลไม่ถูกต้องจะไม่สามารถแก้ไขได้ในภายหลัง (ต้องติดต่อเจ้าหน้าที่)'
            : 'Please review the information carefully before confirming. Once submitted, it cannot be modified later. (You will need to contact our staff for any corrections.)'
  "
  [isButtonConfirm]="true"
  [language]="currentLang"
  (submit)="saveApi()"
  (cancel)="showModal_confirm = false"
></app-pss-warn>
<!-- Modal -->
<div
  *ngIf="isModalOpen"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
>
  <div class="bg-white w-full max-w-lg rounded-lg shadow-lg p-6 relative">
    <button
      (click)="closeModal()"
      class="absolute top-2 right-2 text-gray-500 hover:text-black"
    >
      ✕
    </button>

    <h2 class="text-lg font-semibold mb-4">
      {{
        currentLang === "TH"
          ? "เงื่อนไขการบริการ / นโยบายความเป็นส่วนตัว"
          : "Terms of Service / Privacy Policy"
      }}
    </h2>
    <div class="text-sm text-gray-700 space-y-3 max-h-[400px] overflow-y-auto">
      <p>
        {{
          currentLang === "TH"
            ? "1. ผู้ใช้งานยินยอมให้ระบบจัดเก็บข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ในการยืนยันและอนุมัติการเปลี่ยนแปลงทะเบียนรถในระบบบัตรสมาชิก"
            : "1. Users consent to the collection of personal data for the purpose of verifying and approving vehicle registration changes within the membership card system."
        }}
      </p>
      <p>
        {{
          currentLang === "TH"
            ? "2. ผู้ใช้งานตกลงที่จะอัปโหลดภาพถ่ายของ “เล่มทะเบียนรถ” ที่เป็นของตนจริงและจะต้องเป็นภาพที่ชัดเจนและถูกต้องตามความเป็นจริง"
            : "2. Users agree to upload a photograph of their own official vehicle registration book. The image must be clear, accurate, and truthful."
        }}
      </p>
      <p>
        {{
          currentLang === "TH"
            ? "3. ระบบจะใช้ภาพถ่ายและข้อมูลทะเบียนเพื่อการตรวจสอบและเก็บประวัติการใช้งานโดยชอบธรรมตามกฎหมาย"
            : "3. The system will use the uploaded photograph and registration information solely for verification and lawful record-keeping purposes."
        }}
      </p>
      <p>
        {{
          currentLang === "TH"
            ? "4. ข้อมูลส่วนบุคคลและภาพถ่ายที่จัดเก็บจะได้รับการดูแลรักษาอย่างปลอดภัยและจะไม่ถูกนำไปใช้เพื่อวัตถุประสงค์อื่นนอกเหนือจากที่ระบุไว้"
            : "4. All collected personal data and images will be securely stored and will not be used for any purposes beyond those specified."
        }}
      </p>
      <p>
        {{
          currentLang === "TH"
            ? "5. ผู้ใช้งานสามารถติดต่อขอแก้ไข หรือลบข้อมูลส่วนบุคคลได้ภายหลัง โดยยื่นคำร้องผ่านช่องทางที่ระบบกำหนด"
            : "5. Users may request to modify or delete their personal information at any time by submitting a request through the designated channels provided by the system."
        }}
      </p>
    </div>
  </div>
</div>

<!-- Modal ดูตัวอย่าง -->
<div
  *ngIf="isSampleVisible"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60"
>
  <div class="bg-white rounded-lg p-4 shadow-lg relative max-w-sm">
    <button
      (click)="hideSampleImage()"
      class="absolute top-1 right-2 text-gray-500 hover:text-black"
    >
      ✕
    </button>
    <h3 class="text-sm font-semibold mb-2">
      {{
        currentLang === "TH"
          ? "ตัวอย่างรูปภาพเล่มทะเบียน"
          : "Example of Vehicle Registration Book Image"
      }}
    </h3>
    <img src="/images/unnamed.jpg" alt="Example" class="w-full rounded" />
  </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
